import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { validateVendorGuideSearch } from '@/features/buying/order-guide/api';
import { VendorGuideScreen } from '@/features/buying/order-guide/VendorGuideScreen';

/**
 * /purchasing/guide/$vendorId — one vendor's order guide (TASK-0229). Un-nested
 * like the board; the screen and its typed quantities live in
 * features/buying/order-guide.
 */
export const Route = createFileRoute('/_app/purchasing_/guide_/$vendorId')({
  staticData: { crumb: 'Order guide' },
  validateSearch: validateVendorGuideSearch,
  component: VendorGuideRoute,
});

function VendorGuideRoute() {
  const { vendorId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <VendorGuideScreen
      vendorId={Number(vendorId)}
      search={search}
      onSearch={(patch, options) =>
        void navigate({
          search: (prev) => ({ ...prev, ...patch }),
          replace: options?.replace ?? false,
        })
      }
    />
  );
}
